var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lock-course"},[_c('Form',{attrs:{"form_type":_vm.type}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }